/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExportRequestGenericOntology } from '../../models/export-request-generic-ontology';

export interface UpdateExportRequestTicketOntology$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected ontology
 */
  ontologyUid: string;
  
    /**
     * Body for new ontology on demand of export
     */
    body: ExportRequestGenericOntology
}

export function updateExportRequestTicketOntology(http: HttpClient, rootUrl: string, params: UpdateExportRequestTicketOntology$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateExportRequestTicketOntology.PATH, 'put');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('ontologyUid', params.ontologyUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateExportRequestTicketOntology.PATH = '/export-request/{uid}/ontology/ticket/{ontologyUid}';
